import { ICustomIconProps } from './types';

const IconStarFilled: React.FC<ICustomIconProps> = ({ size = 20, color = '#00CC3A', className }) => (
  <svg width={size} height={size} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path
      d='M12.825 4.34169L14 6.69169C14.1583 7.01669 14.5833 7.32503 14.9416 7.39169L17.0666 7.74169C18.425 7.96669 18.7416 8.95003 17.7666 9.93336L16.1083 11.5917C15.8333 11.8667 15.675 12.4084 15.7666 12.8L16.2416 14.85C16.6166 16.4667 15.75 17.1 14.325 16.25L12.3333 15.0667C11.975 14.85 11.375 14.85 11.0166 15.0667L9.02497 16.25C7.59997 17.0917 6.73331 16.4667 7.10831 14.85L7.58331 12.8C7.65831 12.4 7.49997 11.8584 7.22497 11.5834L5.56664 9.92503C4.59164 8.95003 4.90831 7.96669 6.26664 7.73336L8.39164 7.38336C8.74997 7.32503 9.17497 7.00836 9.33331 6.68336L10.5083 4.33336C11.15 3.06669 12.1833 3.06669 12.825 4.34169Z'
      fill={color}
    />
    <path
      d='M6.66669 4.79169H1.66669C1.32502 4.79169 1.04169 4.50835 1.04169 4.16669C1.04169 3.82502 1.32502 3.54169 1.66669 3.54169H6.66669C7.00835 3.54169 7.29169 3.82502 7.29169 4.16669C7.29169 4.50835 7.00835 4.79169 6.66669 4.79169Z'
      fill={color}
    />
    <path
      d='M4.16669 16.4583H1.66669C1.32502 16.4583 1.04169 16.175 1.04169 15.8333C1.04169 15.4916 1.32502 15.2083 1.66669 15.2083H4.16669C4.50835 15.2083 4.79169 15.4916 4.79169 15.8333C4.79169 16.175 4.50835 16.4583 4.16669 16.4583Z'
      fill={color}
    />
    <path
      d='M2.50002 10.625H1.66669C1.32502 10.625 1.04169 10.3417 1.04169 10C1.04169 9.65833 1.32502 9.375 1.66669 9.375H2.50002C2.84169 9.375 3.12502 9.65833 3.12502 10C3.12502 10.3417 2.84169 10.625 2.50002 10.625Z'
      fill={color}
    />
  </svg>
);

export default IconStarFilled;
